import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/firebaseConfig';
import { AccountPortalShell, HGhostButton } from '../h';
import { ShippedSummary } from './ShippedSummary';

/* Shown right after the user confirms shipping addresses (or signs back in
   while addresses are confirmed but not yet `preparingForShipping`).

   Visually nearly identical to PreparingForShipping (v9 1.6/1.7) — same
   ShippedSummary body — but copy emphasises "received" rather than "packing".

   Note: there's no separate v9 mockup for this state; v9 treats both the
   "we got it" and "we're packing" phases under the same 1.6/1.7 design. */
function ThankYouPreShipment({
  isReturningUser = false, // unused now — copy is the same either way
  email,
  numOfFamilies = 1,
  shippingAddressAtOrder,
  nameFromServer,
  shippingAddresses,
}) {
  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Sign out error', error);
    }
  };

  return (
    <AccountPortalShell
      rightSlot={
        <HGhostButton onClick={handleSignOut} className="text-[12px]">
          Sign out
        </HGhostButton>
      }
    >
      <ShippedSummary
        email={email}
        numOfFamilies={numOfFamilies}
        shippingAddresses={shippingAddresses}
        shippingAddressAtOrder={shippingAddressAtOrder}
        nameFromServer={nameFromServer}
        phase="received"
      />
    </AccountPortalShell>
  );
}

export default ThankYouPreShipment;
